/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Road_Dude_Meta_TitleInputs */

const en_road_dude_meta_title = /** @type {(inputs: Road_Dude_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hit the Road Dude AI | State Property Meme & Video Prompts`)
};

const zh_road_dude_meta_title = /** @type {(inputs: Road_Dude_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hit the Road Dude AI 视频案例与提示词 | 私人领地梗`)
};

/**
* | output |
* | --- |
* | "Hit the Road Dude AI \| State Property Meme & Video Prompts" |
*
* @param {Road_Dude_Meta_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const road_dude_meta_title = /** @type {((inputs?: Road_Dude_Meta_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Road_Dude_Meta_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_road_dude_meta_title(inputs)
	return zh_road_dude_meta_title(inputs)
});
export { road_dude_meta_title as "road_dude.meta.title" }